export default {
  loggedUser: (state) => state.loggedUser,
  isLoggedIn: (state) => {
    return state.loggedUser.token !== null
  },
  hasPermission: (state, rootState) => ({ resource, operation = 'View' }) => {
    return (
      rootState.loggedUser.permissions.filter(
        (x) =>
          x.resource === resource && (x.operationsList.split(',').includes(operation) || x.operationsList === 'All')
      ).length === 1
    )
  },
  isRoutePublic: state => route => {
    // Using getters with extra arguments: https://goo.gl/7kQaiF
    return typeof route.meta.isPublic !== 'undefined'
  },
  menuItems: (state, rootState) => {
    let menuItems = [
      {
        name: 'Locations',
        route: '/location',
        description: 'Optional brief description.',
        icon: 'bank',
        showReportIcon: true,
        isAdminOnly: true
      },
      {
        name: 'Users',
        route: '/user',
        description: 'Optional brief description.',
        icon: 'account-multiple',
        showReportIcon: false,
        isAdminOnly: true
      },
      {
        name: 'Groups',
        route: '/group',
        description: 'Optional brief description.',
        icon: 'cube',
        showReportIcon: true,
        isAdminOnly: true
      },
      {
        name: 'Buildings',
        route: '/building',
        description: 'Optional brief description.',
        icon: 'domain',
        showReportIcon: true,
        isAdminOnly: true
      },
      {
        name: 'Surveys',
        route: '/survey',
        description: 'Optional brief description.',
        showReportIcon: false,
        icon: 'animation'
      }
    ]

    return rootState.loggedUser.role === 'User' ? menuItems.filter((x) => !x.isAdminOnly) : menuItems
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js